import { render, staticRenderFns } from "./CrudEntityEditor.vue?vue&type=template&id=535cca4d&scoped=true"
import script from "./CrudEntityEditor.vue?vue&type=script&lang=ts"
export * from "./CrudEntityEditor.vue?vue&type=script&lang=ts"
import style0 from "./CrudEntityEditor.vue?vue&type=style&index=0&id=535cca4d&prod&scoped=true&lang=scss"
import style1 from "./CrudEntityEditor.vue?vue&type=style&index=1&id=535cca4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535cca4d",
  null
  
)

export default component.exports